export * from "/vercel/path0/node_modules/.pnpm/posthog-js@1.186.1/node_modules/posthog-js/react/dist/esm/index.js"